module.exports = __webpack_public_path__ + "img/img1.b0f12b56.jpg";